import { makeAutoObservable, runInAction } from 'mobx'
import { MarketingService } from '~/shared/api/services/marketing'
import { Loaders } from './types'
import { SelectOption } from '~/shared/ui'
import { mapDataForSelect } from '~/shared/lib'

export class MarketingStore {
  loaders: Loaders = {
    products: false,
    loadMoreSales: false,
    loadMoreCoupons: false,
    categoriesForModal: false,
    categoriesForDiscount: false,
    categoriesForCoupon: false,
    createSlider: false,
    sales: false,
    coupons: false,
    sliders: false,
    stores: false,
    createCoupon: false,
    createSale: false,
    deleteSale: false,
    deleteSlider: false,
    createSlide: false,
    deleteCoupon: false,
    updateSlider: false,
  }

  categoriesForDiscount: SelectOption[] = []

  categoriesForCoupon: SelectOption[] = []

  categoriesForModal: SelectOption[] = []

  subContentOpens: string[] = []

  constructor() {
    makeAutoObservable(this)
  }

  setIdsSubContentOpens = (id: string) => {
    this.subContentOpens = this.subContentOpens.includes(id)
      ? this.subContentOpens.filter((e) => e !== id)
      : [...this.subContentOpens, id]
  }

  activeLoader = (key: keyof Loaders) => {
    this.loaders = { ...this.loaders, [key]: true }
  }

  closeLoader = (key: keyof Loaders) => {
    this.loaders = { ...this.loaders, [key]: false }
  }

  getCategories = async (
    mobxStoreName:
      | 'categoriesForModal'
      | 'categoriesForCoupon'
      | 'categoriesForDiscount',
    findStoreId?: string,
    q?: string,
  ) => {
    this.activeLoader(mobxStoreName)

    try {
      const { data } = await MarketingService.getCategories({
        params: {
          ...(findStoreId ? { storeId: findStoreId } : {}),
          ...(q?.trim() ? { q: q.trim() } : {}),
        },
      })

      runInAction(() => {
        if (mobxStoreName === 'categoriesForModal') {
          this[mobxStoreName] = data.map((el) => ({
            label:
              el.localizations?.find((lang) => lang.languageCode === 'RU')
                ?.name || el.name,
            value: el.id,
            slug: el.slug,
          })) as SelectOption[]
        } else {
          this[mobxStoreName] = mapDataForSelect(data, 'id', 'name')
        }

        this.closeLoader(mobxStoreName)
      })
    } catch (error: unknown) {
      runInAction(() => {
        this.closeLoader(mobxStoreName)
      })
    }
  }

  clearCategoriesForModal = () => {
    this.categoriesForModal = []
  }

  clearCategoriesForCoupon = () => {
    this.categoriesForCoupon = []
  }
}

export default MarketingStore
